'use client';
import { jsxs, jsx } from 'react/jsx-runtime';
import { forwardRef } from 'react';

const PaymentMaestroWithTextAsset = ({ width, height, ...props }, ref) => /* @__PURE__ */ jsxs(
  "svg",
  {
    viewBox: "0 0 84 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ...props,
    width,
    height,
    ref,
    "aria-hidden": true,
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "rect",
        {
          x: 0.5,
          y: 0.5,
          width: 83,
          height: 57,
          rx: 3.5,
          fill: "white",
          stroke: "#E1E0DF"
        }
      ),
      /* @__PURE__ */ jsx("path", { d: "M49.6664 37.823H35.3055V12.1855H49.6664V37.823Z", fill: "#6C6BBD" }),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M36.2171 25.0048C36.2171 19.8042 38.6683 15.1715 42.4855 12.1861C39.6941 10.003 36.1712 8.69999 32.3425 8.69999C23.2785 8.69999 15.931 15.9998 15.931 25.0048C15.931 34.0099 23.2785 41.3097 32.3425 41.3097C36.1712 41.3097 39.6941 40.0067 42.4855 37.8236C38.6683 34.8381 36.2171 30.2055 36.2171 25.0048Z",
          fill: "#EB001B"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M69.0409 25.0048C69.0409 34.0099 61.6934 41.3097 52.6294 41.3097C48.8007 41.3097 45.2778 40.0067 42.4853 37.8236C46.3036 34.8381 48.7548 30.2055 48.7548 25.0048C48.7548 19.8042 46.3036 15.1715 42.4853 12.1861C45.2778 10.003 48.8007 8.69999 52.6294 8.69999C61.6934 8.69999 69.0409 15.9998 69.0409 25.0048Z",
          fill: "#0099DF"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M54.5254 45.0674C54.7163 45.0674 54.9908 45.1037 55.2005 45.1856L54.9083 46.0729C54.708 45.991 54.5076 45.9641 54.3156 45.9641C53.6958 45.9641 53.3858 46.3621 53.3858 47.0774V49.5051H52.4373V45.1762H53.3765V45.7018C53.6227 45.3214 53.9786 45.0674 54.5254 45.0674Z",
          fill: "#231F20"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M51.0213 46.0367H49.4717V47.9928C49.4717 48.4271 49.6261 48.7173 50.1009 48.7173C50.3472 48.7173 50.6571 48.6355 50.9389 48.4727L51.2123 49.2782C50.9117 49.4865 50.438 49.614 50.0279 49.614C48.9061 49.614 48.5148 49.0159 48.5148 48.0104V46.0367H47.6299V45.1763H48.5148V43.8629H49.4717V45.1763H51.0213V46.0367Z",
          fill: "#231F20"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M40.0623 45.0674C41.2842 45.0674 42.1232 45.991 42.1326 47.3407C42.1326 47.4661 42.1234 47.5824 42.1141 47.6996L42.1138 47.7025H38.8779C39.0146 48.4809 39.5708 48.7619 40.1812 48.7619C40.6185 48.7619 41.0839 48.5991 41.4481 48.3089L41.9135 49.0065C41.3844 49.4502 40.7833 49.6129 40.127 49.6129C38.8226 49.6129 37.8928 48.7163 37.8928 47.3407C37.8928 45.991 38.786 45.0674 40.0623 45.0674ZM40.0446 45.9091C39.3694 45.9091 38.9875 46.3352 38.8863 46.9602H41.1476C41.0474 46.2895 40.655 45.9091 40.0446 45.9091Z",
          fill: "#231F20"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M46.2983 46.2813C46.0343 46.1175 45.4969 45.9092 44.9407 45.9092C44.421 45.9092 44.1111 46.0999 44.1111 46.4171C44.1111 46.7063 44.4388 46.7882 44.8489 46.8421L45.2955 46.9054C46.2441 47.0422 46.818 47.4402 46.818 48.2011C46.818 49.0252 46.0886 49.614 44.8311 49.614C44.1195 49.614 43.4631 49.4326 42.9434 49.0522L43.39 48.3183C43.7093 48.5629 44.1842 48.7712 44.8405 48.7712C45.4875 48.7712 45.834 48.5815 45.834 48.2457C45.834 48.0021 45.5877 47.8653 45.068 47.7937L44.6214 47.7305C43.6457 47.5937 43.1166 47.1593 43.1166 46.4534C43.1166 45.593 43.8283 45.0674 44.9313 45.0674C45.6242 45.0674 46.2535 45.2219 46.7084 45.5204L46.2983 46.2813Z",
          fill: "#231F20"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M58.9301 45.2426C58.6421 45.1254 58.3291 45.0674 57.991 45.0674C57.6529 45.0674 57.3398 45.1254 57.0518 45.2426C56.7638 45.3587 56.5165 45.5193 56.3078 45.7236C56.0991 45.9278 55.9352 46.1693 55.8163 46.4471C55.6973 46.726 55.6378 47.0287 55.6378 47.3552C55.6378 47.6817 55.6973 47.9844 55.8163 48.2633C55.9352 48.5411 56.0991 48.7836 56.3078 48.9879C56.5165 49.1921 56.7638 49.3517 57.0518 49.4688C57.3398 49.5849 57.6529 49.643 57.991 49.643C58.3291 49.643 58.6421 49.5849 58.9301 49.4688C59.2181 49.3517 59.4675 49.1921 59.6773 48.9879C59.8881 48.7836 60.0519 48.5411 60.1709 48.2633C60.2898 47.9844 60.3493 47.6817 60.3493 47.3552C60.3493 47.0287 60.2898 46.726 60.1709 46.4471C60.0519 46.1693 59.8881 45.9278 59.6773 45.7236C59.4675 45.5193 59.2181 45.3587 58.9301 45.2426ZM57.4473 46.0636C57.6153 45.9962 57.7958 45.962 57.991 45.962C58.1861 45.962 58.3677 45.9962 58.5346 46.0636C58.7026 46.132 58.8487 46.2274 58.9708 46.3497C59.095 46.472 59.191 46.6192 59.262 46.7902C59.3319 46.9613 59.3663 47.1499 59.3663 47.3552C59.3663 47.5615 59.3319 47.7491 59.262 47.9201C59.191 48.0912 59.095 48.2384 58.9708 48.3607C58.8487 48.483 58.7026 48.5784 58.5346 48.6468C58.3677 48.7152 58.1861 48.7484 57.991 48.7484C57.7958 48.7484 57.6153 48.7152 57.4473 48.6468C57.2803 48.5784 57.1353 48.483 57.0132 48.3607C56.8911 48.2384 56.7951 48.0912 56.7252 47.9201C56.6552 47.7491 56.6208 47.5615 56.6208 47.3552C56.6208 47.1499 56.6552 46.9613 56.7252 46.7902C56.7951 46.6192 56.8911 46.472 57.0132 46.3497C57.1353 46.2274 57.2803 46.132 57.4473 46.0636Z",
          fill: "#231F20"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M36.8754 45.1762V47.3407V49.5051H35.9279V48.9796C35.6263 49.3693 35.1713 49.614 34.5515 49.614C33.3295 49.614 32.3726 48.6623 32.3726 47.3407C32.3726 46.018 33.3295 45.0674 34.5515 45.0674C35.1713 45.0674 35.6263 45.312 35.9279 45.7018V45.1762H36.8754ZM34.6693 45.9547C33.8491 45.9547 33.3472 46.5798 33.3472 47.3407C33.3472 48.1015 33.8491 48.7256 34.6693 48.7256C35.453 48.7256 35.9821 48.1285 35.9821 47.3407C35.9821 46.5528 35.453 45.9547 34.6693 45.9547Z",
          fill: "#231F20"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          d: "M31.5336 49.5051V46.7882C31.5336 45.765 30.8772 45.0767 29.8202 45.0674C29.264 45.0581 28.689 45.2301 28.2883 45.8376C27.9877 45.3576 27.5129 45.0674 26.8472 45.0674C26.3828 45.0674 25.9268 45.2032 25.5709 45.7101V45.1762H24.6234V49.5051H25.5803V47.1054C25.5803 46.3538 25.9998 45.9547 26.6468 45.9547C27.276 45.9547 27.5954 46.3621 27.5954 47.096V49.5051H28.5523V47.1054C28.5523 46.3538 28.9906 45.9547 29.6188 45.9547C30.2668 45.9547 30.5767 46.3621 30.5767 47.096V49.5051H31.5336V49.5051Z",
          fill: "#231F20"
        }
      )
    ]
  }
);
const VpPaymentMaestroWithTextAsset = forwardRef(PaymentMaestroWithTextAsset);

export { VpPaymentMaestroWithTextAsset as default };
